import { TErrorDescriptor } from '../../Common/ErrorHandling/store'

export const isInstanceOfIThunkError = (
  object: any,
): object is TErrorDescriptor => {
  return object.errorType in object
}
